const initialState = {
    car_addOn: JSON.parse(localStorage.getItem('car_addOn')) || [],
};

const carAddOnReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CAR_ADD_ON_LIST':
            localStorage.setItem('car_addOn', JSON.stringify(action.payload));
            return {
                ...state,
                car_addOn: action.payload,
            };
        default:
            return state;
    }
};

export default carAddOnReducer;